<template>
  <section class='leaveStu'>
    <Row>
      <Breadcrumb>

        <BreadcrumbItem to="">APP管理</BreadcrumbItem>
        <BreadcrumbItem to="">昵称审核</BreadcrumbItem>

      </Breadcrumb>
    </Row>
    <Row xs="20" sm="16" md="12" lg="8">

      <Col span='4'>
      <Input v-model="searchParam.name" placeholder="请输入姓名或手机号" />
      </Col>
      <Col span='2'>
      <Button type="info" @click='searchData'>查询</Button>
      </Col>
      <div class='menubtn'>
        <Button type="success" @click='addItem(1)'>审核通过</Button>
        &nbsp;&nbsp;
        <Button type="info" @click='addItem(2)'>审核不通过</Button>
      </div>
    </Row>
    <section class='tabelContent'>
      <tablePage border :queryData="queryData" :searchParam='searchParam' @selectLcd='selectLcd' :issearch='issearch'
        @smodal='sModal'></tablePage>
    </section>
    <Modal v-model="edituser" title='用户修改' width='700px' :mask-closable='false'>
      <Form :model="formItem" :label-width="120">
        <section id='con'>

          <!-- <Form-item label="是否管理员">
                        <RadioGroup v-model="formItem.isadmin">

                          <Radio label="0">否</Radio>
                          <Radio label="1">是</Radio>
                        </RadioGroup>
                      </Form-item> -->
          <Form-item label="是否可用">
            <RadioGroup v-model="formItem.state">
              <Radio label="1">禁用</Radio>
              <Radio label="0">可用</Radio>
            </RadioGroup>
          </Form-item>

        </section>
      </Form>

      <div slot="footer" style='position:relative;clear:both'>

        <!-- <Button type="error" @click='removeItem' class='remove' icon="md-trash" v-if='this.formItem.id!=""'>删除</Button> -->
        <Button type="default" @click='edituser = false' icon="md-close">取消</Button>
        <Button type="info" @click='postNews(true)' icon="md-checkmark-circle-outline">保存</Button>
      </div>

    </Modal>



  </section>
</template>

<script>

import tablePage from './tablePage'
import selftree from './inputTree'
import util from '../utils/index.js'
export default {
  name: 'appuser',
  components: {
    tablePage,
    selftree,
  },
  data () {
    return {
      edituser: false,
      lanmu: [],
      mewsto: [],
      newstoData: [],
      isnewModal: false,
      treekey: -1,
      checkSchool: [],
      userDrawer: false,
      smodal: false,
      reloadTmep: -1,
      initformData: [],
      hideInputNum: -1,
      queryData: ['appUser/dataList?nickstate=0',
        [
          {
            type: 'selection',
            width: 60,
            align: 'center'
          },
          {
            title: '头像/昵称',
            key: '',
            width: 240,
            ellipsis: true,
            render: (h, params) => {
              var pic = params.row.imgurlNew ? params.row.imgurlNew : ''
              var _firstLetter = ''
              var nickname = params.row.nicknameNew ? decodeURIComponent(params.row.nicknameNew) : params.row.nickname
              if (nickname) {
                _firstLetter = nickname.substr(0, 1)
              }
              var _zd = {
                style: {
                  color: "#ed4c78",
                  backgroundColor: "rgba(237,76,120,.1)",
                  padding: "2px 8px",
                  borderRadius: '7px',
                  fontSize: '11px',
                  display: 'inline-block',
                  marginRight: '4px',
                }
              }
              var _isno = ''
              if (params.row.state == 1) {
                _isno = h('span', _zd, '已禁用')
              }
              if (pic) {
                return h('viewer', [
                  h('img', {
                    style: {//设置样式
                      display: 'inline-block',
                      width: '30px',
                      height: '30px',
                      borderRadius: '50%',
                      textAlign: 'center',
                      lineHeight: '30px',
                      position: 'absolute',
                    },
                    attrs: {//设置属性
                      src: pic
                    }
                  }),
                  h('span', {
                    style: {
                      fontWeight: 'bold',

                      height: '30px',
                      paddingLeft: '45px',
                      lineHeight: '30px',
                    },
                  }, nickname || ''),
                  _isno
                ]
                )
              } else {
                return h('div', [
                  h('span', {

                    style: {
                      display: 'inline-block',
                      width: '30px',
                      height: '30px',
                      background: 'rgba(237,76,120,.1)',
                      borderRadius: '50%',
                      textAlign: 'center',
                      lineHeight: '30px',
                      color: '#ed4c78',
                      position: 'absolute',

                    },
                  }, _firstLetter),
                  h('span', {
                    style: {
                      fontWeight: 'bold',

                      height: '30px',
                      paddingLeft: '45px',
                      lineHeight: '30px',
                    },
                  }, nickname),
                  _isno
                ])
              }
            }
          },

          {
            title: '认证等级',
            key: 'lv',
            align: 'center',
            render: (h, params) => {
              return h('span', 'LV' + params.row.lv)
            }
          },
          {
            title: '是否管理员',
            key: '',
            align: 'center',
            render: (h, params) => {
              if (params.row.isadmin == 1) {
                return h('span', '是')
              }

            }
          },
          {
            title: '手机号码',
            key: 'phone',
            align: 'center',
          },
          {
            title: '手机类型',
            key: 'phonetype',
            align: 'center',
          },
          {
            title: '注册时间',
            key: 'addtime',
            align: 'center',
          },
          {
            title: '区域',
            key: 'area',
            align: 'center',
          },
          {
            title: '操作',
            slot: 'action',
            width: 100,
            align: 'center',
            render: (h, params) => {
              return h('div', [
                h('span', {
                  style: {
                    display: 'inline-block',
                    width: '60px',
                    height: '25px',
                    background: '#2db7f5',
                    borderRadius: '6px',
                    textAlign: 'center',
                    lineHeight: '25px',
                    color: '#fff',
                    fontSize: '12px',
                    cursor: 'pointer',
                    userSelect: 'none'
                  },
                  on: {
                    click: () => {


                      this.curStuInfo = params.row

                      this.getId(params.row.guid)
                      // user.isPrincipal = user.isPrincipal == 1 ? true : false
                      // user.state = user.state == 1 ? true : false


                    }
                  }
                }, '编辑')
              ])
              // <span class='do' @click="show(index,row)">编辑</span>
            }
          }

        ]
      ],
      searchParam: {
        name: '',
        text: '',
      },
      issearch: -1,
      signData: [],
      lcdData: [],
      partData: [],
      roleData: [],
      schoolData: [],
      kmData: [],
      curUser: {},
      inputtext: '',
      curStuInfo: {},
      selectList: [],
      formItem: {
        state: '0',
        isadmin: '0'
      },
    }
  },
  props: {
    fromheadschoolid: {
      default: -1
    }
  },
  watch: {
    fromheadschoolid (newval, oldval) {
      console.log(newval, oldval)
      this.curSchoolid = newval
      this.queryData[0] = 'appUser/dataList?isPrincipal=-1&schoolid=' + newval
      this.reloadTable()
    },
  },
  mounted () {
    var that = this
    var userInfo = JSON.parse(localStorage.getItem('inchUserinfo'))
    this.curSchoolid = localStorage.getItem('curSchoolid')
    this.queryData[0] = 'appUser/dataList'

  },
  methods: {
    addItem (state) {
      console.log(this.selectList)
      var that = this
      var len = this.selectList.length
      this.selectList.map(function (val, index) {
        var param = {
          guid: val['guid'],
          state: state,
          unionid: val['unionid']
        }
        console.log(index, len, that.selectList)
        that.axios.post('appUser/updateNickState', param).then(res => {
          console.log(res)
          if (index == len - 1) {
            that.issearch = Math.random()
          }
        })
      })



    },
    selectLcd (a) {
      console.log(a)
      this.selectList = a
    },
    getId (id) {
      var that = this
      this.formItem = {
        state: '0',
        isadmin: '0',
        guid: '',
      }
      this.lanmu = []
      this.mewsto = []
      this.edituser = true
      that.treekey = Math.random()
      if (id != -1) {
        this.isnewModal = false
        this.axios.get('appUser/getId.do', { params: { guid: id } }).then(res => {
          console.log(res)
          that.formItem.state = String(res.data.state)
          that.formItem.isadmin = String(res.data.isadmin)
          that.formItem.guid = res.data.guid
        })
      }

    },
    postNews () {
      var that = this
      var param = {
        isadmin: this.formItem.isadmin,
        state: this.formItem.state,
        guid: this.formItem.guid,

      }
      console.log(param, 'parm')

      this.axios.post('appUser/save', param).then(res => {
        if (res.success) {
          that.$Message.info(res.msg)
          that.reloadTable()
          that.edituser = false
        } else {
          that.$Message.error(res.msg)
        }
      })
    },
    getRolelist () {
      var that = this
      this.axios.get('sysRole/dataList', { params: {} }).then(res => {
        console.log(res, 'res')
        that.newstoData = res.data
      })
    },
    exportData () {
      var param = {

        name: this.searchParam.name,
        length: -1
      }

      var tHeader = ['姓名', '账号', '任课班级', '班主任']
      var filterVal = ['name', 'username', 'classname', 'headerClassName']
      util.exportExcel('appUser/dataList?isPrincipal=-1', param, '教师账号', tHeader, filterVal)


    },
    searchData () {
      const result = /^\d+$/.test(this.searchParam.text)
      console.log(result)
      if (result) {
        this.searchParam.phone = this.searchParam.text
        this.searchParam.name = ''
      } else {
        this.searchParam.phone = ''
        this.searchParam.name = this.searchParam.text
      }
      this.issearch = Math.random()
    },
    sModal (guid) {
      console.log(guid, 'guid', this.formData[0][0])
      this.reloadTmep = Math.random()
      if (this.formData[0][0].indexOf('?') > -1) {
        this.formData[0][0] = this.formData[0][0].split('?')[0]
      }
      this.formData[0][0] = this.formData[0][0] + '?id=' + guid
      if (guid == -1) {
        this.formData[1] = JSON.parse(JSON.stringify(this.initformData))
      }
    },
    reloadTable () {
      this.issearch = Math.random()
    },
    hideInput (e) {

      this.hideInputNum = Math.random()
    },
    saveData () {
      //	this.getClassName(this.schoolData,this.curUser.classid.split(','))
      var that = this
      console.log(this.curUser.headteacher)
      var headteach = this.curUser.headteacher ? this.curUser.headteacher : ''
      headteach = typeof (headteach) == "object" ? headteach[headteach.length - 1] : headteach.split(",")[2]

      if (headteach == undefined) {
        headteach = -1
      }
      if (this.curUser.username == '') {
        that.$Message.error('请填写用户名')
        return false
      }


      if (typeof (this.curUser.classid) == 'string') {

      } else {
        this.curUser.classid = this.curUser.classid ? this.curUser.classid.join(',') : ''
      }
      if (this.curUser.classid == '') {
        that.$Message.error('请选择任课班级')
        return false
      }
      var param = {
        id: this.curUser.id,
        username: this.curUser.username,
        name: this.curUser.name,
        headteacher: Number(headteach),
        classid: this.curUser.classid,
        className: this.inputtext,
        course: this.curUser.course,
        selRoles: this.curUser.roleIds ? this.curUser.roleIds.join(',') : '',
        roleName: this.curUser.roleIds ? this.getRole(this.curUser.roleIds) : '',
        isPrincipal: this.curUser.isPrincipal == true ? 1 : 0,
        state: this.curUser.state == true ? 0 : 1,
        departid: this.curUser.departid ? this.curUser.departid.join(',') : '',
        depart: this.curUser.departid ? this.getDepart(this.curUser.departid) : '',
        signconfig: this.curUser.signconfig,
        pushclass: this.curUser.pushclass ? this.curUser.pushclass.join(',') : '',
        deviceid: this.curUser.lcds ? this.curUser.lcds.join(',') : '',
        deviceidName: this.curUser.lcds ? this.curUser.lcds.join(',') : '',
        cardno: this.curUser.cardno,
        face: this.curUser.face,
        guid: this.curUser.guid
      }
      if (this.curUser.id == '') {
        delete param['id']
      }
      console.log(param)
      console.log(this.curUser)

      this.axios.post('appUser/save.do', param).then(res => {
        if (res.success) {
          that.$Message.info(res.msg)
          that.reloadTable()
          that.userDrawer = false
        } else {
          that.$Message.error(res.msg)
        }
      })
    },
    getSingleInfo (id) {
      var that = this
      this.edituser = true

      console.log(id)
      if (id != -1) {
        this.isnewModal = false
        this.axios.get('appUser/getId.do', { params: { id: id } }).then(res => {
          console.log(res)
          that.treekey = Math.random()


        })
      } else {
        this.isnewModal = true
        this.curUser = {
          selRoles: '',
          username: '',
          password: '',
          name: '',
          itemids: '',
        }
        that.treekey = Math.random()
      }

    },
    resetItem () {
      var that = this
      this.curUser['headteacher'] = []
      that.treekey = Math.random()
    },
    removeItem () {
      var that = this
      this.$Modal.confirm({
        title: '提示',
        content: '<p>是否确认删除？</p>',
        onOk: () => {
          console.log(that.curStuInfo)
          var param = {
            id: that.curStuInfo.guid
          }

          that.axios.post('appUser/delete.do', param).then(res => {
            if (res.success) {
              that.$Message.info(res.msg)
              that.reloadTable()
              that.edituser = false
            } else {
              that.$Message.error(res.msg)
            }
          })
        },
        onCancel: () => {

        }
      });
    },
    changeRenke (val) {
      console.log(val)
      this.formItem.itemids = val['classid'].split(',')
    },
    changeClass (val) {
      console.log(val)
      this.curUser.pushclass = val['onlyClassid'].split(",")
      //this.curUser.pushclass =val['onlyClassid'].split(",")
    },
    changehead (val) {
      console.log(val)
      this.curUser.headteacher = val['onlyClassid'].split(",")
      // this.curUser.headteacher = val['onlyClassid'].split(",")
    },
    getDepart (id) {
      var name = ''
      var partData = this.partData
      for (var i = 0; i < partData.length; i++) {
        for (var j = 0; j < id.length; j++) {
          if (partData[i]['id'] == id[j]) {
            name += partData[i]['name'] + ','
          }
        }
      }
      console.log(id, partData)
      return name.substring(0, name.length - 1)
    },
    getRole (id) {
      var name = ''
      var partData = this.roleData
      for (var i = 0; i < partData.length; i++) {
        for (var j = 0; j < id.length; j++) {
          if (partData[i]['id'] == id[j]) {
            name += partData[i]['name'] + ','
          }
        }
      }

      return name.substring(0, name.length - 1)
    },
    getClassName (tree, ids) {

      for (var i = 0; i < tree.length; i++) {
        for (var j = 0; j < ids.length; j++) {
          if (tree[i]['id'] == ids[j]) {
            this.inputtext += tree[i]['name'] + ','
          }
        }
        if (tree[i]['children'].length > 0) {
          this.getClassName(tree[i]['children'], ids)
        }
      }
    },
    getHeadTeach (id) {
      var data = this.schoolData
      for (var i = 0; i < data.length; i++) {
        for (var j = 0; j < data[i]['children'].length; j++) {
          if (data[i]['children'][j]['id'] == id) {
            return data[i]['id']
          }
        }

      }
    }
  }
}
</script>

<style scoped>
.tabelContent {
  margin-top: 20px;
}

.leaveStu {
  flex: 1;
  padding-right: 25px !important;
  /* overflow: scroll; */
  padding-bottom: 50px;
  padding-top: 20px;
  overflow-x: hidden;
}

.leaveStu .ivu-row:first-of-type {
  margin-top: 5px;
}

.leaveStu .ivu-row {
  margin-top: 20px;
  /* 	overflow:hidden; */
  position: relative;
}

.leaveStu .ivu-col {
  margin-right: 10px;
  /* float:left; */
}

.leaveStu .ivu-col:last-of-type {
  float: left;
  margin-left: 10px;
  /* position:absolute;
		right:0px; */
}

.demo-upload-list {



  border: 1px solid transparent;
  border-radius: 4px;
  overflow: hidden;
  background: #fff;
  position: relative;
  overflow: hidden;
  margin-right: 4px;
  margin-bottom: 5px;
}

.demo-upload-list img {
  width: 40px;
  height: 40px;
  float: left;
  margin-right: 15px;
}

.demo-upload-list span {
  line-height: 40px;
  font-size: 12px;
  float: left;
}

.demo-upload-list-cover {
  display: none;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, .6);
}

.demo-upload-list:hover .demo-upload-list-cover {
  display: block;
}

.demo-upload-list-cover i {
  color: #fff;
  font-size: 20px;
  cursor: pointer;
  margin: 0 10px;
  line-height: 40px;

}

#hwSchool {
  position: relative;
}

#hwSchool .ivu-tree {
  position: absolute;
  top: 33px;
  left: 0px;
  background: #fff;
  z-index: 1000;
  width: 300px;
  height: 300px;
  border: 1px solid #dcdee2;
  border-top: 0 none;
  overflow-y: scroll;
  overflow-x: hidden;
  padding-left: 10px;
}

.modalUl {
  width: 100%;
  display: flex;
  justify-content: space-between;


}

.modalUl li {
  list-style: none;

}

.modalUl>li:first-of-type {
  width: 35%;
  height: 100%;
  height: 400px;
  overflow-y: scroll;
  overflow-x: hidden;
}

.modalUl>li:last-of-type {
  flex: 1;
  padding-left: 30px;
}

.treeContent {}

.hwImgCon {
  margin-top: 10px;

}

.hwImgCon img {
  width: 55px;
  height: 55px;
  border-radius: 5px;
}

.conheadRight {
  float: right;

}

.avatar {
  width: 60px;
  height: 60px;
  border-radius: 8px;
  margin-right: 20px;
}

#userStyle li {
  display: flex;
  justify-content: flex-start;
  list-style: none
}

#userStyle li h6 {
  font-size: 16px;
  height: 30px;
  line-height: 30px;
  margin-top: -2px;
}

#userStyle .avatarinfo p {
  font-size: 12px;
  position: relative;
  top: 2px;
}

#userStyle .avatarinfo .ivu-input-wrapper {}

#userStyle ul {
  margin-bottom: 30px;
}

.selfRow {
  overflow: visible;
  width: 100%;
}

.selfRow .nor:first-of-type {
  float: left;
  width: 48%
}

.selfRow .nor:last-of-type {
  float: right;
  width: 48%
}

.selfswitch {
  width: 50%;
  box-sizing: border-box;
  padding-left: 6px;
  float: left;
}

#userStyle {
  margin: 0px 10px;
  padding-bottom: 20px;
}

.remove {
  float: left;
  margin-left: 8px;
}

.ivu-drawer-body {
  padding-bottom: 100px;
}

.drawFooter {
  width: 560px;
  position: fixed;
  bottom: 0;
  right: 0;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  background: #fff;
  overflow: hidden;
}

/* #con{
    display:flex;
    justify-content: space-between;
  } */
</style>
